
import Dialog from 'primevue/dialog'
import { Options, Vue } from 'vue-class-component'
@Options({
  components: { Dialog }
})
export default class SiteNavbar extends Vue {
  showModal = false
}
